import { render, staticRenderFns } from "./serviceCloud2.vue?vue&type=template&id=8fea2512&scoped=true"
import script from "./serviceCloud2.vue?vue&type=script&lang=js"
export * from "./serviceCloud2.vue?vue&type=script&lang=js"
import style0 from "./serviceCloud2.vue?vue&type=style&index=0&id=8fea2512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fea2512",
  null
  
)

export default component.exports